<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 20:22:22
 * @LastEditTime: 2019-08-26 21:56:56
 * @LastEditors: Please set LastEditors
 -->
<!--  -->
<template>
  <div class="tdt-bottom tdt-right">
    <div
      class="tdt-control-zoom tdt-bar tdt-control"
      style="left: -10px; top: -30px; color: rgb(0, 0, 0);"
    >
      <div class="zoom_number" @dblclick="_zoomLevelDblclickHandler">{{zoomLevel}}</div><a
        @click="_zoomInClickHandler"
        title="放大"
        style="text-align: center;background-color: #fff;float: left; width: 16px; height: 20px; line-height: 20px; font-size: 13px; text-indent: 0px;"
      >+</a><a
      @click="_zoomOutClickHandler"
        title="缩小"
        style="text-align: center;background-color: #fff;float: left; width: 16px; height: 20px; line-height: 20px; font-size: 13px; text-indent: 0px;"
      >-</a>
    </div>

  </div>

</template>

<script>

import {UCZoomControlEvent} from "./UCZoomControlJs.js";


export default {
  name: "UCZoomControl",
  data() {
    return {
      zoomLevel:12,


    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    
    init()
    {

    },

    changeZoomLevel(zoomLevel)
    { 
      this.zoomLevel=zoomLevel;
    },

    on_zoomLevelDoubleClick(callback)
    { 
      if(callback)
      {
        this.$on(UCZoomControlEvent.UCZoomControl_event_zoomLevelDoubleClick,callback);
      }
      
    },

    on_zoomInClick(callback)
    { 
      if(callback)
      {
        this.$on(UCZoomControlEvent.UCZoomControl_event_zoomInClick,callback);
      }
    },

    on_zoomOutClick(callback)
    { 
      if(callback)
      {
        this.$on(UCZoomControlEvent.UCZoomControl_event_zoomOutClick,callback);
      }

    },

    _zoomLevelDblclickHandler()
    { 
      this.$emit(UCZoomControlEvent.UCZoomControl_event_zoomLevelDoubleClick);
    },
    
    _zoomInClickHandler()
    {
      this.$emit(UCZoomControlEvent.UCZoomControl_event_zoomInClick);
    },


    _zoomOutClickHandler()
    {
      this.$emit(UCZoomControlEvent.UCZoomControl_event_zoomOutClick);
    }
    


  }
};


</script>
<style lang="scss" scoped>
.tdt-control-zoom .zoom_number {
  border: 1px solid #000;
  background: #000;
  color: #fff;
  opacity: 0.7;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 13px;
  font-weight: 700;
}

.tdt-bar {
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
}

.tdt-control {
  margin-bottom: 20px;
  float: right;
  margin-right: 23px;
}

.tdt-bottom {
  bottom: 0;
}
.tdt-right {
  right: 0;
}
.tdt-bottom,
.tdt-top {
  position: absolute;
  z-index: 1000;
  cursor: pointer;
}
</style>